export const ACCOUNT_ROLE_ADMIN = 0;
export const ACCOUNT_ROLE_PARENT = 1;
export const ACCOUNT_ROLE_CHILD = 2;
